package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable

@Serializable
open class SignSymptomSettingAccompaniedBy(var id: String? = null){
	var signSymptomSettingId: String? = null
	var accompaniedSymptomId: String? = null
	var description: String? = null
	var weight: Int? = null
	var associateContentId: String? = null
	var associateContent: String? = null
	var forDoctorOnly: Byte? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomSettingAccompaniedBy
		if (id != other.id) return false
		if (signSymptomSettingId != other.signSymptomSettingId) return false
		if (accompaniedSymptomId != other.accompaniedSymptomId) return false
		if (description != other.description) return false
		if (weight != other.weight) return false
		if (associateContentId != other.associateContentId) return false
		if (associateContent != other.associateContent) return false
		if (forDoctorOnly != other.forDoctorOnly) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (signSymptomSettingId?.hashCode() ?: 0)
		result = 31 * result + (accompaniedSymptomId?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (associateContentId?.hashCode() ?: 0)
		result = 31 * result + (associateContent?.hashCode() ?: 0)
		result = 31 * result + (forDoctorOnly?.hashCode() ?: 0)
		return result
	}

}
